import { unwrapCollection } from './model';
export function readAchievements(response) {
  const result = response?.data?.data ?? response?.data;
  const collection = unwrapCollection({ data: result?.collection });
  if (!Array.isArray(result.newlyUnlockedBadges)) throw Error('Invalid achievements');
  const goals = (result.completedMusicGoals ?? []).filter(
    (g) => ['WEEK', 'MONTH'].includes(g?.periodType) && typeof g.periodStart === 'string',
  );
  const badges = result.newlyUnlockedBadges.filter(
    (b) => b?.key && (!collection.unseenBadgeKeys || collection.unseenBadgeKeys.includes(b.key)),
  );
  return {
    collection,
    notices: [
      ...goals.map((goal) => ({
        type: 'goal',
        goal,
        key: `goal:${goal.periodType}:${goal.periodStart}`,
      })),
      ...(badges.length
        ? [
            {
              type: 'badge',
              badge: badges[0],
              extraCount: badges.length - 1,
              key: `badge:${badges
                .map((b) => `${b.key}:${b.unlockedAt ?? ''}`)
                .sort()
                .join('|')}`,
            },
          ]
        : []),
    ],
  };
}
